import { Utils } from 'ecrion-components';

function getResourceToken(workspace, path, publicAccessToken = null) {
  const headers = {};
  if (publicAccessToken)
    headers.Authorization = `Basic ${btoa(publicAccessToken)}`;

  return Utils.request({
    method: 'GET',
    url: `${process.env.REACT_APP_WEBSITE_URL}/backend/fileresourcetoken?workspace=${workspace}&filepath=${path}`,
    headers: headers,
  }).then(resourceToken => {
      return resourceToken;
  });
}

export { getResourceToken };
